import * as tslib_1 from "tslib";
/**
 * @file Abstract class representing a control owned by a AbstractView instance.
 * @author Tom Verschoore de la Houssaije.
 */
import { OnDestroy } from '@angular/core';
import { AbstractComponent } from '../../core/helpers/abstract-component';
import { DataType } from 'breeze-client';
import { DomainService } from '../../domain.service';
/**
 * Abstract class representing a control owned by a AbstractView instance.
 * A ControlBase has an instruction to help and instruct the user how to use the control.
 * A ControlBase can save and restore its last state.
 */
var ControlBase = /** @class */ (function (_super) {
    tslib_1.__extends(ControlBase, _super);
    /**
     * Constructs a ControlBase
     * @param configurationsService The configuration service.
     * @memberOf ControlBase
     */
    function ControlBase(alertsService) {
        var _this = _super.call(this, alertsService) || this;
        _this.alertsService = alertsService;
        /**
         * Flag indicating wether the instruction is open for reading.
         * @private
         * @memberOf ControlBase
         */
        _this._isInstructionOpen = false;
        /**
         * The default value of this property is false.
         * The value is set to true when the app displays the control in the overlay mode.
         * Use this property to make the control "overlay mode" responsive.
         * @memberOf ControlBase
         */
        _this.overlayMode = false;
        return _this;
    }
    /**
     * Toggles the showing and hiding of the instruction of the control.
     * @memberOf ControlBase
     */
    ControlBase.prototype.toggleInstructionOpen = function () {
        this._isInstructionOpen = !this._isInstructionOpen;
    };
    /**
     * The instruction of the control is shown when this flag is true.
     * @returns True when the instruction of the control is shown otherwise false.
     * @memberOf ControlBase
     */
    ControlBase.prototype.isInstructionOpen = function () {
        return this._isInstructionOpen;
    };
    /**
     * We save, OnDestroy, the state of the control set by the user.
     * @memberOf ControlBase
     */
    ControlBase.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this.configuration) {
            this.saveUserData(this.configuration.key);
        }
    };
    /**
     * Is called after the block name is set and the configuration is loaded.
     * @memberOf ControlBase
     */
    ControlBase.prototype.afterInitialize = function () {
        // // Bugfix for #2376
        // setTimeout(() => {
        //     this.restoreState(this.configuration.key);
        // }, 1);
        // Bugfix for #2376 veroorzaakte nu issue #3320
        // Issue #2376 treed niet meer op ook zonder de Bugfix van hier boven.
        this.restoreState(this.configuration.key);
    };
    /**
     * Override this method to implement logic to store the control state set by the user.
     * @protected
     * @param {string} configKey Reference to the appropiate configuration. Use this reference to save and find the stored state of the control.
     * @memberOf ControlBase
     */
    ControlBase.prototype.restoreState = function (configKey) { };
    /**
     * Override this method to implement logic to restore the last control state set by the user.
     * @protected
     * @abstract
     * @param {string} configKey Reference to the appropiate configuration. Use this reference to save and find the stored state of the control.
     * @memberOf ControlBase
     */
    ControlBase.prototype.saveUserData = function (configKey) { };
    /**
     * Set default values to undefined FieldConfiguration properties.
     * @static
     * @param {FieldConfiguration} field The FieldConfiguration to check.
     * @param {EntityType} entityType The associated entity type.
     * @memberOf ControlBase
     */
    ControlBase.setFieldDefaults = function (field, entityType) {
        // TODO: Consider to move to core/forms
        if (field.readonly === undefined) {
            field.readonly = false;
        }
        var property;
        var currentType = entityType;
        var path = field.name.split('.');
        path.forEach(function (segment, index) {
            if (index < path.length - 1) {
                var nav = DomainService.getNavigationPropertyFor(currentType, segment);
                if (nav) {
                    currentType = nav.entityType;
                }
            }
            else {
                property = DomainService.getDataPropertyFor(currentType, segment);
                if (!property) {
                    property = DomainService.getNavigationPropertyFor(currentType, segment);
                }
            }
        });
        if (field.editor === undefined) {
            if (!property) {
                field.editor = 'string';
            }
            else {
                if (field.required === undefined) {
                    field.required = property.validators.some(function (validator) { return validator.name === 'required'; });
                }
                ControlBase.setDefaultEditorFor(property, field, entityType);
            }
        }
    };
    /**
     * Set the FieldConfiguration editor and formats for a specific entity property type.
     * @static
     * @param {(DataProperty | NavigationProperty)} property The associated entity property.
     * @param {FieldConfiguration} field The FieldConfiguration to check.
     * @param {EntityType} entityType The associated entity type.
     * @memberOf ControlBase
     */
    ControlBase.setDefaultEditorFor = function (property, field, entityType) {
        var dataType = property.dataType;
        if (dataType) {
            switch (dataType) {
                case DataType.Boolean:
                    field.editor = 'boolean';
                    break;
                case DataType.Time:
                    field.editor = 'duration';
                    break;
                case DataType.DateTime:
                    field.editor = 'datetime';
                    break;
                case DataType.String:
                    if (!property.validators.some(function (validator) {
                        switch (validator.name) {
                            case 'emailAddress':
                                field.editor = 'email';
                                return true;
                            case 'url':
                                field.editor = 'url';
                                return true;
                            case 'phone':
                                field.editor = 'phone';
                                return true;
                            default:
                                return false;
                        }
                    })) {
                        field.editor = 'string';
                    }
                    break;
                default:
                    field.editor = dataType.isNumeric ? 'number' : 'string';
                    break;
            }
        }
        else if (property.isScalar) {
            // NavigationProperty
            var typeEntity = property.entityType;
            if (typeEntity.shortName === 'Repeat') {
                field.editor = 'repeat';
                return;
            }
            if (typeEntity.defaultResourceName) {
                field.editor = 'entity';
                field.format = {
                    dataSource: typeEntity.defaultResourceName,
                    entity: typeEntity.shortName,
                    fields: ['Name']
                };
            }
            else {
                // TODO: Deze situatie zou niet meer voor komen bij de back-end.
                field.editor = 'string';
                field.name += '.Name';
            }
        }
    };
    return ControlBase;
}(AbstractComponent));
export { ControlBase };
